import { render, staticRenderFns } from "./principalMailBoxDocx.vue?vue&type=template&id=81e91b4a&"
import script from "./principalMailBoxDocx.vue?vue&type=script&lang=js&"
export * from "./principalMailBoxDocx.vue?vue&type=script&lang=js&"
import style0 from "./principalMailBoxDocx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports